import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Activity, CalendarDays, CheckSquare, IndianRupee, Settings2, Users2, Wallet, Clock3 } from "lucide-react";
import LiveBoard from "@/components/hr/LiveBoard";
import EmployeeAttendance from "@/components/hr/EmployeeAttendance";
import Holidays from "@/components/hr/Holidays";
import Approvals from "@/components/hr/Approvals";
import SalaryStructure from "@/components/hr/SalaryStructure";
import Payroll from "@/components/hr/Payroll";
import HrSettings from "@/components/hr/HrSettings";
import Geofencing from "@/components/hr/Geofencing";
import { MapPinned } from "lucide-react";
import ShiftRoster from "@/components/hr/ShiftRoster";
import ShiftCalendar from "@/components/hr/ShiftCalendar";
import KioskPhotos from "@/components/hr/KioskPhotos";

const TABS = [["live", "Live board", Activity], ["attendance", "Attendance", CalendarDays], ["approvals", "Leaves & grace", CheckSquare], ["holidays", "Holidays", CalendarDays], ["shifts", "Shift roster", Clock3], ["salary", "Salary structure", Users2], ["payroll", "Payroll", Wallet], ["geo", "Geofencing", MapPinned], ["settings", "Policy", Settings2]];

export default function HR() {
  const [tab, setTab] = useState("live");
  const [employees, setEmployees] = useState([]);
  const [empId, setEmpId] = useState("");
  const load = () => api.get("/hr/employees").then(r => setEmployees(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const unpaid = employees.filter(e => !e.salary?.monthly_salary).length;
  return (
    <div className="space-y-6" data-testid="hr-page">
      <header className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div><div className="text-[11px] tracking-[0.2em] uppercase text-zinc-500 font-semibold">Human resources</div><h1 className="font-heading font-black tracking-tight text-3xl sm:text-4xl mt-2">Duty hours, attendance &amp; payroll</h1></div>
        {unpaid ? <button type="button" onClick={() => setTab("salary")} className="text-xs text-amber-800 bg-amber-50 border border-amber-200 px-3 py-2 flex items-center gap-2" data-testid="hr-unpaid-warning"><IndianRupee size={13} /> {unpaid} employee(s) have no monthly salary set — payroll will show ₹0 for them</button> : null}
      </header>
      <div className="flex gap-1 overflow-x-auto border-b border-zinc-200 -mx-1 px-1">
        {TABS.map(([k, l, I]) => <button key={k} type="button" data-testid={`hr-tab-${k}`} onClick={() => setTab(k)} className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap ${tab === k ? "border-zinc-900 text-zinc-900" : "border-transparent text-zinc-500 hover:text-zinc-900"}`}><I size={14} /> {l}</button>)}
      </div>
      {tab === "live" ? <><LiveBoard onOpenEmployee={(id) => { setEmpId(id); setTab("attendance"); }} /><KioskPhotos /></> : null}
      {tab === "attendance" ? <EmployeeAttendance employees={employees} employeeId={empId} onEmployee={setEmpId} /> : null}
      {tab === "approvals" ? <Approvals employees={employees} onChanged={load} /> : null}
      {tab === "holidays" ? <Holidays employees={employees} /> : null}
      {tab === "shifts" ? <div className="space-y-4"><ShiftCalendar /><ShiftRoster employees={employees} onChanged={load} /></div> : null}
      {tab === "salary" ? <SalaryStructure employees={employees} onChanged={load} /> : null}
      {tab === "payroll" ? <Payroll onOpenSalary={() => setTab("salary")} /> : null}
      {tab === "geo" ? <Geofencing /> : null}
      {tab === "settings" ? <HrSettings /> : null}
    </div>
  );
}
